import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const Cross: FC<IconProps> = (props) => (
  <Icon {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h32v32H0z" />
      <path
        fill="currentColor"
        d="M24.485 6.101a1.2 1.2 0 0 1 1.697 0l.717.717a1.2 1.2 0 0 1 0 1.697L18.414 17l8.485 8.485a1.2 1.2 0 0 1 0 1.697l-.717.717a1.2 1.2 0 0 1-1.697 0L16 19.414l-8.485 8.485a1.2 1.2 0 0 1-1.697 0l-.717-.717a1.2 1.2 0 0 1 0-1.697L13.586 17 5.101 8.515a1.2 1.2 0 0 1 0-1.697l.717-.717a1.2 1.2 0 0 1 1.697 0L16 14.586l8.485-8.485Z"
      />
    </g>
  </Icon>
);
